<template>
    <div>
        <v-form-item
            :rules="rules"
            @error="errorHandler"
            name="menuMsg"
            label="按钮动作"
            required="请选择"
        >
            <v-radio-group
                v-model="radio"
                class="action-types-group"
            >
                <v-radio
                    :value="ACTION_TYPE.ACTION_APPLET"
                    v-if="supportActionValues.indexOf(ACTION_TYPE.ACTION_APPLET)>-1"
                    name="action-radio"
                >
                    跳转小程序
                </v-radio>
                <v-radio
                    :value="ACTION_TYPE.ACTION_REPLY"
                    name="action-radio"
                >
                    系统自动回复
                    <v-icon
                        v-tip:replyTip.hover
                        name="input_question"
                        class="tip-icon"
                    />
                    <v-tip
                        ref="replyTip"
                        kind="small"
                        placement="top"
                    >
                        <div class="question-radio-tip">
                            <div class="question-radio-tip-text">
                                客户点击后，系统自动回复设置的固定图片/文本内容，建议设置常见问题，提升响应速度
                            </div>
                            <div class="question-radio-tip-replay" />
                        </div>
                    </v-tip>
                </v-radio>
                <v-radio
                    :value="ACTION_TYPE.ACTION_WEB"
                    v-if="supportActionValues.indexOf(ACTION_TYPE.ACTION_WEB)>-1"
                    name="action-radio"
                >
                    跳转网页
                </v-radio>
                <v-radio
                    :value="ACTION_TYPE.ACTION_VISITOR"
                    name="action-radio"
                >
                    客户快速发送
                    <v-icon
                        v-tip:visitorTip.hover
                        name="input_question"
                        class="tip-icon"
                    />
                    <v-tip
                        ref="visitorTip"
                        kind="small"
                        placement="top"
                    >
                        <div class="question-radio-tip">
                            <div class="question-radio-tip-text">
                                客户点击后，快速发送设置的文本内容，节省描述时间。建议配置常见问题、转人工关键词等，可能随不同机器人触发差异化回复、转接人工。（不可关联动作，不会触发自动回复）
                            </div>
                            <div class="question-radio-tip-visitor" />
                        </div>
                    </v-tip>
                </v-radio>
                <v-radio
                    :value="ACTION_TYPE.ACTION_SYSTEM"
                    :disabled="isSystemEnable"
                    name="action-radio"
                >
                    系统事件
                    <v-icon
                        v-tip:systemTip.hover
                        name="input_question"
                        class="tip-icon"
                    />
                    <v-tip
                        ref="systemTip"
                        kind="small"
                        placement="top"
                    >
                        <div>
                            1套“输入框上方互动按钮”<br />
                            只能配置1次相同的系统事件
                        </div>
                    </v-tip>
                </v-radio>
            </v-radio-group>
        </v-form-item>

        <div class="behavior-com">
            <template v-if="radio === ACTION_TYPE.ACTION_REPLY">
                <reply-box
                    key="ACTION_REPLY"
                    :reply="metaVal"
                    :index="index"
                    :boxOptions="boxOptions"
                    @change="onChangeItemReply"
                    @error="(msg)=>errorHandler(msg, radio)"
                />
            </template>
            <template v-if="radio === ACTION_TYPE.ACTION_VISITOR">
                <reply-box
                    key="ACTION_VISITOR"
                    :reply="metaCopy"
                    :index="index"
                    :boxOptions="visiterBoxOptions"
                    @change="onChangeItemReply"
                    @error="(msg)=>errorHandler(msg, radio)"
                />
            </template>
            <applet-href
                v-if="radio === ACTION_TYPE.ACTION_APPLET && supportActionValues.indexOf(radio)>-1"
                :hrefVal="metaVal"
                @pushMsg="pushMsg"
                @error="(msg)=>errorHandler(msg, radio)"
            />
            <web-href
                v-if="radio === ACTION_TYPE.ACTION_WEB && supportActionValues.indexOf(radio)>-1"
                :hrefVal="metaVal"
                @pushMsg="pushMsg"
                @error="(msg)=>errorHandler(msg, radio)"
            />
            <SystemEvent
                v-if="radio === ACTION_TYPE.ACTION_SYSTEM"
                :meta="metaVal"
                :menu="menu"
                :index="index"
                @change="syschange"
                @error="(msg)=>errorHandler(msg, radio)"
            />
            <div
                v-if="loading"
                class="spring-box"
            >
                <v-spinner>加载中...</v-spinner>
            </div>
        </div>
    </div>
</template>

<script>
import AppletHref from './applet-href';
import WebHref from './web-href';
import SystemEvent from './/system-event';
import ReplyBox from './reply-box';

import _lang from 'lodash/lang';
import { REPLY_TXT_TYPE, REPLY_IMG_TYPE, REPLY_APPLET_PLUGIN_TYPE, REPLY_IMG_TXT_TYPE } from './reply-box/src/config';
import { ACTION_TYPE, CHANNEL_WEB, CHANNEL_APPLET, SYSTEMEVNT, SYSTEMEVNT_ECOMMERCE } from '../../constants';
import { getECommerceStatus } from '@/cgi/getECommerceStatus';

export default {
    name: 'MenuMsg',
    components: {
        AppletHref,
        ReplyBox,
        WebHref,
        SystemEvent,
    },
    props: {
        menu: {
            type: Object,
            default: () => ({}),
        },
        index: {
            type: Number | String,
            default: '',
        },
        action: {
            type: Number | undefined,
            default: ACTION_TYPE.ACTION_REPLY,
        },
        meta: {
            type: Object,
            default: () => ({}),
        },
        channelType: {
            type: Number,
            default: CHANNEL_APPLET,
        },
    },
    data() {
        return {
            loading: true,
            rules: [
                {
                    validate(value) {
                        return !!value;
                    },
                    message: '按钮动作未指定',
                },
            ],
            radio: '', // 1ACTION_REPLY系统自动回复, 2ACTION_APPLET跳转小程序, 3ACTION_VISITOR 访客快速发送
            ACTION_TYPE,
            currentReplyInfo: {}, // 当前自动回复数据
            metaVal: {},
            // metaCopy 的作用：
            // metaCopy 是 metaVal 副本。
            // 因为 ‘系统自动回复’ 和 ‘访客快速发送’ 都使用了 ‘reply-box’ 组件。
            // 其内部读取的数据名称都是一样的，如果不区分，两者的数据就会被混用。
            metaCopy: {},
            CHANNEL_WEB,
            CHANNEL_APPLET,
            innerErrorList: {},
            // 是否正在被销毁
            isDestorying: false,
            // 支持的事件列表。
            dynamicySystemEvent: [...SYSTEMEVNT],
        };
    },
    computed: {
        isSystemEnable() {
            return this.radio !== ACTION_TYPE.ACTION_SYSTEM  && this.menu.list.filter(item => item.action === ACTION_TYPE.ACTION_SYSTEM).length >= this.dynamicySystemEvent.length;
        },
        boxOptions() {
            const appletOptions = [REPLY_TXT_TYPE, REPLY_IMG_TYPE, REPLY_APPLET_PLUGIN_TYPE];
            const webOptions = [REPLY_IMG_TXT_TYPE, REPLY_IMG_TYPE, REPLY_TXT_TYPE];
            return this.channelType === CHANNEL_WEB ? webOptions : appletOptions;
        },
        visiterBoxOptions() {
            const appletOptions = [REPLY_TXT_TYPE, REPLY_IMG_TYPE, REPLY_APPLET_PLUGIN_TYPE];
            const webOptions = [REPLY_TXT_TYPE];
            return this.channelType === CHANNEL_WEB ? webOptions : appletOptions;
        },

        /** 支持的动作列表 */
        supportActionValues() {
            const actions = {...ACTION_TYPE};
            //网页通路，移除挑战小程序
            if (this.channelType === CHANNEL_WEB) {
                delete actions.ACTION_APPLET;
            }
            //小程序通路，移除网页跳转
            if (this.channelType === CHANNEL_APPLET) {
                delete actions.ACTION_WEB;
            }
            return Object.values(actions);
        },
    },
    watch: {
        index(val) {
            this.initData();
        },
        radio(newVal) {
            // 如果是 ‘访客发送’， 就使用 copy数据
            const returnData = newVal === ACTION_TYPE.ACTION_VISITOR ? this.metaCopy : this.metaVal;
            this.$emit('pushMsg', returnData, newVal, this.index);
        },
        meta: {
            handler(newVal) {
                this.initData();
            },
            deep: true,
        },
    },
    async mounted() {
        // 检测是否有电商工具包。
        if (await getECommerceStatus()) {
            this.dynamicySystemEvent = [...SYSTEMEVNT, ...SYSTEMEVNT_ECOMMERCE];
        }

        this.initData();
    },
    beforeDestroy() {
        this.isDestorying = true;
    },
    methods: {
        syschange(val) {
            this.$emit('pushMsg', val, this.radio, this.index);
        },
        initData() {
            this.loading = true;
            this.radio = this.action;
            // 如果已选的action 不支持，就使用第一个
            if (this.supportActionValues.indexOf(this.radio) === -1) {
                this.radio = this.supportActionValues[0];
                console.warn('当前选项不支持，使用默认值');
            }

            // 如果是 ‘访客回复’，就把数据存到 copy中
            if(this.radio === ACTION_TYPE.ACTION_VISITOR){
                this.metaCopy = { ...this.meta };
            } else {
                this.metaVal = { ...this.meta };
            }

            this.loading = false;
        },
        // 改变菜单/按钮动作回调
        onChangeItemReply(value) {
            // 删除自动回复消息，控件返回的是一个空对象，需要做特殊判断
            value.id && (value.materialId = value.id);
            value.showUrl && (value.imgurl = value.showUrl);
            if (_lang.isEmpty(value)) {
                value = { replyType: 0 };
            }
            this.$emit('pushMsg', value, this.radio, this.index);
        },
        pushMsg(val) {
            this.$emit('pushMsg', val, this.radio, this.index);
        },

        /** 错误处理 */
        errorHandler(msg, type) {
            // 此处特殊逻辑的说明：
            // 背景：为了解决子组件切换时，错误显示不刷新，会在子组件销毁时情况其内部错误。
            // 而当menu.list发生删除操作时，会先处罚 list.slice, 然后才销毁组件，进而触发子组件的错误清理逻辑。
            // 而当清理错误逻辑传到导最终处理逻辑时，该list中其实已经不存在需要被处理的数据item了。
            // 因此，如果该组件正在销毁，则不抛出错误。
            if (this.isDestorying) {
                return;
            }

            this.innerErrorList[type] = msg;
            // 将当前选项对应的错误抛出
            this.$emit('error', this.innerErrorList[this.radio]);
        },
    },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
